import { render, staticRenderFns } from "./CreatePaymentAdmin.vue?vue&type=template&id=08e06120"
import script from "./CreatePaymentAdmin.vue?vue&type=script&lang=js"
export * from "./CreatePaymentAdmin.vue?vue&type=script&lang=js"
import style0 from "./CreatePaymentAdmin.vue?vue&type=style&index=0&id=08e06120&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports